/**
 * @flow
 */

import Config from 'config';
import request from './request';

export function voidCostItems(ticketId, costItemIds) {
  const data = JSON.stringify({
    ticket_id: ticketId,
    cost_item_ids: costItemIds
  });

  const options = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };

  return request(`${Config.api.base}/tickets/void_cost_items`, options)
    .then(res => res.json());
}
